// extracted by mini-css-extract-plugin
module.exports = {"course":"course_course__2ckiz","demo":"course_demo__1PCcm"};